import { useState } from 'react';
import styled from 'styled-components';

interface SaveButtonProps {
	onClick: () => void;
	disabled?: boolean;
	label?: string;
}

export default function SaveButton(props: SaveButtonProps) {
	const { onClick, disabled, label } = props;

	const [loading, setLoading] = useState<boolean>(false);

	const onClickSave = () => {
		setLoading(true);
		onClick();
	};

	const LoadingContent = (
		<LoadingContainer>
			<span>Saving</span>
			<i className="fas fa-spinner fa-pulse fa-fw"></i>
		</LoadingContainer>
	);

	const buttonLabel = label ? label : 'Save';

	return (
		<button
			className="btn btn-blue btn-sm btn-block rounded-0 border-0"
			onClick={onClickSave}
			disabled={loading || disabled === true}
		>
			{loading ? LoadingContent : buttonLabel}
		</button>
	);
}

const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		margin-right: 0.3rem;
		font-size: 12px;
	}

	i {
		font-size: 0.7rem;
	}
`;
